import { render, staticRenderFns } from "./TotalPondDetail.vue?vue&type=template&id=4bc6163c&scoped=true&"
import script from "./TotalPondDetail.vue?vue&type=script&lang=js&"
export * from "./TotalPondDetail.vue?vue&type=script&lang=js&"
import style0 from "./TotalPondDetail.vue?vue&type=style&index=0&id=4bc6163c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc6163c",
  null
  
)

export default component.exports